import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Image, List, Loader, Segment } from 'semantic-ui-react';
import moment from 'moment';
import Strings from '../../common/Strings';
import { paymentActions } from '../../actions';
import SettingsCard from './SettingsCard';

class PlanAndBillingHistory extends Component {
  render() {
    let Content;
    if (this.props.paymentHistoryLoading) {
      Content = (
        <SettingsCard id="plan-and-billing-payment-history-section">
          <Segment basic style={{ margin: 'auto' }}>
            <Loader inline active size="large" />
          </Segment>
        </SettingsCard>
      );
    } else if (this.props.paymentHistoryFailed) {
      Content = (
        <SettingsCard id="plan-and-billing-payment-history-section">
          <div
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'center',
              display: 'inline-block',
            }}
          >
            <Image
              src="/error/payment_history_error.png"
              className="plan-and-billing-error-image"
              style={{ transform: 'translateX(-7%)' }}
            />
            <p className="plan-and-billing-error-text">
              {Strings.BILLING.paymentHistoryError}
            </p>
            <Button
              className="common-light-button"
              onClick={() => {
                this.props.dispatch(paymentActions.getPaymentHistory());
              }}
            >
              {Strings.BILLING.refresh}
            </Button>
          </div>
        </SettingsCard>
      );
    } else if (this.props.paymentHistory.length === 0) {
      Content = (
        <SettingsCard id="plan-and-billing-payment-history-section">
          <div style={{ margin: 'auto' }}>
            <Image
              className="plan-and-billing-payment-history-empty-image"
              src="/empty/payment_history_empty.svg"
            />
            <p className="plan-and-billing-payment-history-empty">
              {Strings.BILLING.paymentHistoryEmpty}
            </p>
          </div>
        </SettingsCard>
      );
    } else {
      const PaymentHistory = this.props.paymentHistory.map(item => (
        <List.Item key={item.date}>
          <div className="plan-and-billing-payment-history-column">
            <p
              className="plan-and-billing-payment-history-column-title"
              style={{ flex: 0.2 }}
            >
              {moment(item.date).format('MMM D, YYYY')}
            </p>
            <div style={{ flex: 0.3 }}>
              <p className="plan-and-billing-payment-history-column-title">
                {item.brand} **** **** **** {item.last4}
              </p>
              <p className="plan-and-billing-payment-history-column-title">
                {Strings.BILLING.expiration} : {item.expMonth} / {item.expYear}
              </p>
            </div>
            <p
              className="plan-and-billing-payment-history-column-title"
              style={{ flex: 0.2 }}
            >
              {new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: item.currency,
              }).format(item.amount / 100)}
            </p>
            <p
              className="plan-and-billing-payment-history-column-title"
              style={{
                flex: 0.2,
                textTransform: 'capitalize',
                color: item.status === 'failed' ? '#FE6868' : '',
              }}
            >
              {item.status}
            </p>
            <a
              href={item.receiptUrl}
              target="blank"
              className="plan-and-billing-payment-history-column-link"
              style={{ flex: 0.1 }}
            >
              {Strings.BILLING.download}
            </a>
          </div>
          <div
            style={{ height: 1, backgroundColor: '#E3E3E3', marginTop: 10 }}
          />
        </List.Item>
      ));
      Content = (
        <SettingsCard id="plan-and-billing-payment-history-section">
          <div className="plan-and-billing-card-row">
            <div className="plan-and-billing-payment-history-column">
              <p
                className="plan-and-billing-payment-history-column-title"
                style={{ flex: 0.2 }}
              >
                {Strings.BILLING.date}
              </p>
              <p
                className="plan-and-billing-payment-history-column-title"
                style={{ flex: 0.3 }}
              >
                {Strings.BILLING.paymentMethod}
              </p>
              <p
                className="plan-and-billing-payment-history-column-title"
                style={{ flex: 0.2 }}
              >
                {Strings.BILLING.amount}
              </p>
              <p
                className="plan-and-billing-payment-history-column-title"
                style={{ flex: 0.2 }}
              >
                {Strings.BILLING.status}
              </p>
              <p
                className="plan-and-billing-payment-history-column-title"
                style={{ flex: 0.1 }}
              >
                {Strings.BILLING.receipt}
              </p>
            </div>
            <div style={{ height: 1, backgroundColor: '#9B9B9B' }} />
            <List>{PaymentHistory}</List>
          </div>
        </SettingsCard>
      );
    }
    return (
      <div>
        <p className="settings-card-title">{Strings.BILLING.paymentHistory}</p>
        {Content}
      </div>
    );
  }
}

PlanAndBillingHistory.propTypes = {
  dispatch: PropTypes.func.isRequired,
  paymentHistory: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.number.isRequired,
      brand: PropTypes.string.isRequired,
      expMonth: PropTypes.number.isRequired,
      expYear: PropTypes.number.isRequired,
      last4: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
      currency: PropTypes.number.isRequired,
      status: PropTypes.string.isRequired,
      receiptUrl: PropTypes.string.isRequired,
    }),
  ).isRequired,
  paymentHistoryLoading: PropTypes.bool.isRequired,
  paymentHistoryFailed: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  paymentHistory: state.paymentHistory.items,
  paymentHistoryLoading: state.paymentHistory.loading,
  paymentHistoryFailed: state.paymentHistory.failed,
});

export default connect(mapStateToProps)(PlanAndBillingHistory);



// WEBPACK FOOTER //
// ./src/components/settings/PlanAndBillingHistory.js